module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Terminal-00d9f46fe837a87e7ec1b69a41923345.svg";